import type { BotAvatarSet } from "@rakazo/contracts";
import { DEFAULT_NEW_BOT_AVATAR_SET, resolveBotAvatarSet } from "@rakazo/contracts";

/** The avatar set a new bot starts with on this device; each bot can still change its own. */
export const NEW_BOT_AVATAR_SET_STORAGE_KEY = "rakazo.newBotAvatarSet";

const listeners = new Set<() => void>();
let memoryPreference: BotAvatarSet | null = null;

function read(): BotAvatarSet {
  try {
    const raw = localStorage.getItem(NEW_BOT_AVATAR_SET_STORAGE_KEY);
    return raw ? resolveBotAvatarSet(raw) : DEFAULT_NEW_BOT_AVATAR_SET;
  } catch {
    return DEFAULT_NEW_BOT_AVATAR_SET;
  }
}

export function getNewBotAvatarSet(): BotAvatarSet {
  return memoryPreference ?? read();
}

export function setNewBotAvatarSet(set: BotAvatarSet): void {
  memoryPreference = resolveBotAvatarSet(set);
  try {
    localStorage.setItem(NEW_BOT_AVATAR_SET_STORAGE_KEY, memoryPreference);
  } catch {
    // Keep the in-memory preference when storage is unavailable.
  }
  for (const listener of listeners) listener();
}

export function subscribeNewBotAvatarSet(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
